import {
  getTrueFalseSingleChoiceValue,
  PLAYER_PORTALS_MODELS,
} from '@r-and-a-shared-ui/common-kontent-client';

export const player_portals_grid_page = (
  page: PLAYER_PORTALS_MODELS.GridPage,
) => {
  const seo = {
    title: page.elements?.seo__meta_title?.value,
    description: page.elements?.seo__meta_description?.value,
    keywords: page.elements?.seo__key_words?.value,
    noindex: getTrueFalseSingleChoiceValue(page.elements?.seo__no_index),
    nofollow: getTrueFalseSingleChoiceValue(page.elements?.seo__no_follow),
    urlSlug: page.elements?.url_slug?.value,
  };

  return {
    seo,
    pageColumns: page.elements?.page_columns?.linkedItems ?? [],
  };
};

export default player_portals_grid_page;
